const ServiceRepo = {
  serviceData: [
    {
      id: 1,
      icon: "zmdi zmdi-directions",
      title: "Open Data",
      // description: "Records your trip and enter details like vehicle type, waypoints, and count of riders alighting and boarding at each stop, etc. Then view analytics for that track or download the data as GPX, KML, JSON, or CSV files for further analysis on other tools like Google maps, Google Earth, Moovit, ArcGIS, Geo Tracker, etc",
      description:
        "We collect routes and schedules for public transport from commuters, process them, and generate open-sourced GTFS files.",
    },
    {
      id: 2,
      icon: "zmdi zmdi-favorite",
      title: "Affordable Transport",
      description:
        "Cost-sharing gives riders more value for the service received. Helping you to save more--both time and money--is what motivates us",
    },
    {
      id: 3,
      icon: "zmdi zmdi-time",
      title: "Mobility Inclusion",
      description:
        "Our platform improves informal transport networks through cost-effectiveness, use of mobility as a service, and digitization.",
    },
  ],
};

export default ServiceRepo;
